module.exports = __webpack_public_path__ + "img/hearkiosk.38f04623.png";